import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import React, { useContext, useMemo, useRef } from 'react';
import classnames from 'classnames';
import { useResizeObserver } from '@wix/da-hooks/pkg/useResizeObserver';
import { useOnOutsideClick } from '@wix/da-hooks/pkg/useOnOutsideClick';
import { PopupContext } from '../../../popups/PopupContext';
import { noop } from '../../../../utils/noop';
import { setRefs } from '../../../../utils/refHelpers';
import s from './PopoverContainer.scss';
const PopoverContainer = /*#__PURE__*/ React.forwardRef(({ style , placement , directionalClassNames , wrapperClassName , contentClassName , width , height , role , 'aria-label': ariaLabel , children , innerRef , arrow , attributes , onMouseEnter , onMouseLeave , onKeyDown , updatePositioning =noop , onClickOutside =noop  }, ref)=>{
    const { isInPopup  } = useContext(PopupContext);
    const contentRef = useRef(null);
    useResizeObserver(contentRef, updatePositioning);
    // ignore in-popup clicks if not inside one
    const outsideClickRoots = useMemo(()=>isInPopup ? contentRef : [
            contentRef,
            '.ReactModalPortal'
        ], [
        isInPopup
    ]);
    useOnOutsideClick(outsideClickRoots, (e)=>onClickOutside(e), onClickOutside !== noop);
    return /*#__PURE__*/ React.createElement("div", _extends({}, attributes, {
        ref: (node)=>setRefs([
                ref,
                innerRef,
                contentRef
            ], node),
        style: _object_spread({
            width,
            height
        }, style),
        className: classnames(isInPopup ? s['root-in-popup'] : s['root'], directionalClassNames && directionalClassNames[placement], s['popper-wrapper'], wrapperClassName),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onKeyDown: onKeyDown,
        // So we can focus the content wrapper when it mounts if necessary
        tabIndex: -1,
        role: role,
        "aria-label": ariaLabel
    }), /*#__PURE__*/ React.createElement("div", {
        className: classnames(s['popper-content'], height && s['with-scroll'], contentClassName),
        style: {
            width,
            height
        }
    }, children), arrow);
});
PopoverContainer.displayName = 'PopoverContainer';
export default PopoverContainer;
